'use strict';

var currentSearchSingletonModel = require('../../../modules/models/current_search.singleton.model');
var tripTypeUtils = require('../../../modules/utils/trip_type');
var store = require('../../../modules/store/results');
var actions = require('../../../modules/store/results/action_creators');
var sortTypes = require('../../../modules/utils/sort_types');

var createTabView = function(type, selector) {
    return this.viewInjector.create('tab', {
        sortType: sortTypes[type],
        selector: selector,
        tests: this.tests,
    });
};

module.exports = Backbone.View.extend({
    initialize: function(options) {
        this.isDynpack = Odigeo.Utils.isRequestApp('dp');
        this.currentSearchModel = currentSearchSingletonModel.getInstance();
        this.template = options.template;
        this.tabTemplate = options.tabTemplate;
        this.tabInfoTemplate = options.tabInfoTemplate;
        this.viewInjector = options.viewInjector(this);
        this.tests = options.tests;
        this.listenToOnce(this.model.get('translations'), 'change', this.render);
        this.listenTo(this.currentSearchModel, 'change:type', Odigeo._.bind(this.toggleVisibilityOnScopeChange, this));
    },

    calculateDefaultSorting: function() {
        if (this.isDynpack) {
            return sortTypes.byPrice.value;
        } else {
            if (this.tests.sortingTabsPartition === 2) {
                return sortTypes.byRecommended.value;
            } else if (this.tests.sortingTabsPartition === 3) {
                return sortTypes.byPrice.value;
            }
        }
    },

    toggleVisibilityOnScopeChange: function(model, tripType) {
        if (tripTypeUtils.isMultipleDestinations(tripType)) {
            store.dispatch(actions.sortBy(sortTypes.byPrice.value));
            this.$el.addClass('odf-hidden');
        } else {
            const hide = Odigeo.AB.isMobileResults2Batches && !Odigeo.SessionScope.marketingPortalIsMeta;
            this.$el.toggleClass('odf-hidden', hide);
        }
    },

    render: function() {
        this.toggleVisibilityOnScopeChange(this.model, this.currentSearchModel.get('type'));
        this.$el.html(this.template());
        createTabView.call(this, 'byPrice', '.sorting_tab_cheap').render();
        createTabView.call(this, 'byRecommended', '.sorting_tab_best').render();
        createTabView.call(this, 'byDuration', '.sorting_tab_duration').render();
        store.dispatch(actions.sortBy(this.calculateDefaultSorting()));
        return this;
    },
});
